import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
import { useCallback } from 'react';
import CheckBox from '../CheckBox';
function FormikCheckBox(props) {
    const { label, name, onChange = () => null, className = 'checkbox', reverse = false, style = { container: {}, label: {}, checkbox: {} }, defaultValue, ...resProps } = props;
    const { values, setFieldValue } = useFormikContext();
    const value = reverse
        ? !lodashGet(values, name, defaultValue)
        : lodashGet(values, name, defaultValue);
    const changeHandler = useCallback((e) => {
        e.persist();
        onChange(e);
        setFieldValue(name, reverse ? value : !value);
    }, [name, onChange, reverse, setFieldValue, value]);
    return (_jsxs("div", { className: `${className} check-${value}`, style: style.container || {}, children: [label && (_jsx("label", { htmlFor: name, className: "checkbox-label", style: style.label || {}, children: label })), _jsx(CheckBox, { ...resProps, name: name, checked: value, onChange: changeHandler, style: style.checkbox || {} })] }));
}
export default FormikCheckBox;
